import {toast, Flip } from "react-toastify";

const configuracoesPadrao: object = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  transition: Flip,
  theme: "light",
};

export const erroToastifyTimer = (mensagem: string, opcoes: object = {}) => {
  toast.error(mensagem, { ...configuracoesPadrao, ...opcoes });
};

export const erroToastify = (mensagem: string, props?: object) => {
  toast.error(mensagem, { ...configuracoesPadrao, ...props });
};

export const sucessoToastify = (mensagem: string, props?: object) => {
  toast.success(mensagem, { ...configuracoesPadrao, ...props });
};
